const {default: Enum} = require('../base/Enum');

export default class ChatType extends Enum {}

ChatType.riderDriver = new ChatType('RIDER_DRIVER');
ChatType.adminDriver = new ChatType('ADMIN_DRIVER');
